module.exports = __webpack_public_path__ + "static/media/favorite-empty.d4abd38f.svg";